import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39152c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Hieronder vindt u, onderverdeeld per fase, een samenvatting van het door u gekozen meer- en minderwerk."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Standaard opties vindt u niet terug in dit overzicht, enkel het meer- en minderwerk.")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "no-mb"
}
const _hoisted_8 = { class: "tab-subtitle" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de extra fase.", -1))

import { computed, onMounted, ref } from 'vue'
import { authStore } from '@/stores/auth'
import { generalStore } from '@/stores/general'
import { completion2Store } from '@/stores/v2/completion2'
import { summaryStore } from '@/stores/v2/summary'
import WoononSubtotalWidget from '@/components/v2/subtotal/WoononSubtotalWidget.vue'
import WoononSubtotalMobileWidget from '@/components/v2/subtotal/WoononSubtotalMobileWidget.vue'
import WoononSummaryProductsTable from '@/components/v2/summary/WoononSummaryProductsTable.vue'
import WoononPhaseCreateOrder from '@/components/v2/WoononPhaseCreateOrder.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Summary',
  setup(__props) {

const orderAllowed = computed(() => completion2Store().phaseState === 'open' && !authStore().isDemoCustomer)
const activeKey = ref(['modular'])

onMounted(() => {
  completion2Store().getPhaseState()
  summaryStore().getSummary()
})

return (_ctx: any,_cache: any) => {
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "summary",
    gutter: [16,4]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Samenvatting",
            loading: _unref(summaryStore)().loading
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_unref(summaryStore)().summary)
                ? (_openBlock(), _createBlock(_component_a_collapse, {
                    key: 0,
                    activeKey: activeKey.value,
                    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse_panel, {
                        header: "Modulaire keuzes",
                        key: "modular"
                      }, {
                        extra: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(summaryStore)().summary.modular.subtotal_text), 1)
                        ]),
                        default: _withCtx(() => [
                          (_unref(summaryStore)().summary.modular.products.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de modulaire fase."))
                            : _createCommentVNode("", true),
                          _createVNode(WoononSummaryProductsTable, {
                            products: _unref(summaryStore)().summary.modular.products
                          }, null, 8, ["products"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_collapse_panel, {
                        header: "Ruwbouw keuzes",
                        key: "carcass"
                      }, {
                        extra: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(summaryStore)().summary.carcass.subtotal_text), 1)
                        ]),
                        default: _withCtx(() => [
                          (_unref(summaryStore)().summary.carcass.products.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de ruwbouw fase."))
                            : _createCommentVNode("", true),
                          _createVNode(WoononSummaryProductsTable, {
                            products: _unref(summaryStore)().summary.carcass.products
                          }, null, 8, ["products"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_collapse_panel, {
                        header: "Afbouw 1 keuzes",
                        key: "completion1"
                      }, {
                        extra: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(summaryStore)().summary.completion1.subtotal_text), 1)
                        ]),
                        default: _withCtx(() => [
                          (_unref(summaryStore)().summary.completion1.rooms.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de afbouw 1 fase."))
                            : _createCommentVNode("", true),
                          _createVNode(WoononSummaryProductsTable, {
                            products: _unref(summaryStore)().summary.completion1.rooms
                          }, null, 8, ["products"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_collapse_panel, {
                        header: "Afbouw 2 keuzes",
                        key: "completion2"
                      }, {
                        extra: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(summaryStore)().summary.completion2.subtotal_text), 1)
                        ]),
                        default: _withCtx(() => [
                          (_unref(summaryStore)().summary.completion2.rooms.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                _createTextVNode(" Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de afbouw 3 fase."),
                                _hoisted_6,
                                _createTextVNode(" Staat een ruimte er niet tussen? Dan is er door u geen meer- en minderwerk gekozen voor de betreffende ruimte. ")
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_7, "Er is door u (nog) geen meer- minderwerk gekozen voor deze fase.")),
                          _createVNode(_component_a_tabs, { "tab-position": "left" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.completion2.rooms, (room) => {
                                return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                  key: room.level + '-' + room.position
                                }, {
                                  tab: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(room.level) + "." + _toDisplayString(room.position) + " - " + _toDisplayString(room.room_type_text) + " ", 1),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(room.subtotal_text), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(WoononSummaryProductsTable, {
                                      products: room.products,
                                      showPartOf: ""
                                    }, null, 8, ["products"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_collapse_panel, {
                        header: "Afbouw 3 keuzes",
                        key: "completion3"
                      }, {
                        extra: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(summaryStore)().summary.completion3.subtotal_text), 1)
                        ]),
                        default: _withCtx(() => [
                          (_unref(summaryStore)().summary.completion3.products.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de afbouw 3 fase."))
                            : _createCommentVNode("", true),
                          _createVNode(WoononSummaryProductsTable, {
                            products: _unref(summaryStore)().summary.completion3.products
                          }, null, 8, ["products"])
                        ]),
                        _: 1
                      }),
                      (_unref(summaryStore)().summary.extra.products.length)
                        ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                            header: "Extra keuzes",
                            key: "extra"
                          }, {
                            extra: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(summaryStore)().summary.extra.subtotal_text), 1)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_10,
                              _createVNode(WoononSummaryProductsTable, {
                                products: _unref(summaryStore)().summary.extra.products
                              }, null, 8, ["products"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["activeKey"]))
                : _createCommentVNode("", true),
              (_unref(orderAllowed))
                ? (_openBlock(), _createBlock(WoononPhaseCreateOrder, {
                    key: 1,
                    phase: "completion",
                    phaseLabel: "Afbouw"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(WoononSubtotalWidget)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(WoononSubtotalMobileWidget, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})